module.exports = __webpack_public_path__ + "static/slide-1-58a62f0e066421d1508f069a95ad138e.png";